import { render, staticRenderFns } from "./NationalTrademarkNoteType.vue?vue&type=template&id=2fc2777a&"
import script from "./NationalTrademarkNoteType.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkNoteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports